const getParents = (data = []) => data.filter((item) => !item.parent);

const getChildren = (data = [], id) =>
  data.filter((item) => item.parent === id);

const populateService = (services, { id, slug }) =>
  services?.length
    ? services.find((service) => service[id ? '_id' : 'idc'] === (id || slug))
    : {};

const Services = {
  getParents,
  getChildren,
  populateService,
};

export { Services };
